import React, { useState, useEffect } from "react";
import CustomAlert from "../../helpers/CustomAlert";
import { toast } from "react-toastify";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";

const SenderIDModal = ({
  show,
  handleClose,
  customerCode,
  activeTab,
  name,
  senderDetails,
  modalType,
  handleShowTable,
}) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [senderId, setSenderId] = useState("");
  const [senderName, setSenderName] = useState("");
  const [senderIdError, setSenderIdError] = useState("");
  const [senderNameError, setSenderNameError] = useState("");
  const [entityIds, setEntityIds] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { user } = useSelector((state) => state.auth);

  const isReadOnly = !!senderDetails;

  useEffect(() => {
    if (activeTab === "senderIDs") {
      fetchEntityData();
    }
  }, [activeTab]);

  const fetchEntityData = async () => {
    const data = {
      username: loggedInUserName,
      userCode: customerCode,
    };

    try {
      const response = await axiosPostApi(apiList.DLT_FETCH_ENTITY, data);

      if (!response.data.data || response.data.data.length === 0) {
        setErrorMessage("Please, First add an Entity ID.");
      } else {
        const entityIdString =
          response.data.data.length === 1 ? response.data.data[0].entityId : "";
        setEntityIds(entityIdString);
        setErrorMessage(""); // Clear any existing error message
      }
    } catch (error) {
      console.error("Failed to fetch entity data", error);
      setErrorMessage("Error fetching entity data. Please try again.");
    }
  };

  const handleAddSender = async (e) => {
    e.preventDefault();
    let isValid = true;
    // Validate Sender ID
    // if (!senderId) {
    //   setSenderIdError("Sender ID is required");
    //   isValid = false;
    // } else if (senderId.length < 3 || senderId.length > 30) {
    //   setSenderIdError("Sender ID must be 3 to 30 characters long");
    //   isValid = false;
    // } else {
    //   setSenderIdError("");
    // }
    if (!senderId) {
      setSenderIdError("Sender ID is required");
      isValid = false;
    } else if (senderId.includes(" ")) {
      setSenderIdError("Spaces are not allowed");
      isValid = false;
    } else if (!/^[A-Za-z0-9]+$/.test(senderId)) {
      setSenderIdError(
        "Sender ID must contain only uppercase and lowercase letters and digits (A-Z, a-z, 0-9)",
      );
      isValid = false;
    } else if (senderId.length !== 6) {
      setSenderIdError("Sender ID must be exactly 6 characters");
      isValid = false;
    } else if (/^(\d)\1+$/.test(senderId)) {
      setSenderIdError("Sender ID cannot be the same digit repeated");
      isValid = false;
    } else {
      setSenderIdError("");
    }

    // Validate sender Name
    if (!senderName) {
      setSenderNameError("Sender Name is required");
      isValid = false;
    } else if (senderName.length < 2 || senderName.length > 50) {
      setSenderNameError("Sender Name must be 2 to 50 characters long");
      isValid = false;
    } else if (!/^[A-Za-z0-9 ]+$/.test(senderName)) {
      setSenderNameError(
        "Sender Name can only contain letters, numbers, and spaces",
      );
      isValid = false;
    } else if (/^\s|\s$/.test(senderName)) {
      setSenderNameError("Sender Name cannot start or end with spaces");
      isValid = false;
    } else if (/^(\d)\1+$/.test(senderName)) {
      setSenderNameError("Sender Name cannot be the same digit repeated");
      isValid = false;
    } else {
      setSenderNameError("");
    }

    if (!entityIds) {
      toast.error("No entity found. Please add an entity first.");
      return;
    }

    if (!isValid) return;

    const data = {
      username: loggedInUserName,
      sendorId: senderId,
      sendorName: senderName,
      customerCode: customerCode,
      entityId: entityIds,
    };

    try {
      const response = await axiosPostApi(apiList.DLT_ADD_SENDER, data);

      if (response?.status === 200 && response?.data?.status === true) {
        toast.success("sender added successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handleClose();
        setSenderName("");
        setSenderId("");
      } else {
        CustomAlert({
          title: "Failed to Add Sender",
          text:
            response.data.message ||
            "There was an issue processing the request. Please try again.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      toast.error("Failed to add Sender. Please try again.");
    }
  };

  const handleBack = () => {
    if (modalType !== "modify") {
      setSenderName("");
    }
    handleClose();
    setSenderId("");
    setSenderIdError("");
    setSenderNameError("");
  };

  const handleModifyData = async (entity) => {
    if (!senderName) {
      setSenderNameError("Sender Name is required");
      return;
    }

    if (senderName.length < 2 || senderName.length > 50) {
      setSenderNameError("Sender Name must be 2 to 50 characters long");
      return;
    }

    setSenderNameError("");

    const data = {
      username: loggedInUserName,
      sendorId: senderDetails?.id,
      customerCode: customerCode,
      entityId: senderDetails?.entityId,
      sendorName: senderName,
    };

    try {
      setLoading(true);
      const response = await axiosPostApi(apiList.MODIFY_SENDER, data);

      if (response?.status === 200 && response.data.status === true) {
        toast.success("Sender Name Update Successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        handleClose();
        handleShowTable();
      } else {
        // Handle failure case
        CustomAlert({
          title: "Failed to Modify Data",
          text:
            response.data.message ||
            "There was an issue processing the request. Please try again.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        handleClose();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
      CustomAlert({
        title: "Error",
        text: "Something went wrong. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    modalType === "modify" ? handleModifyData() : handleAddSender(e);
  };

  useEffect(() => {
    if (modalType === "modify") {
      setSenderName(senderDetails?.name);
    }
  }, [modalType, senderDetails?.name]);

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="modal-dialog modal-md" role="document">
        <div className="modal-content">
          <div className="modal-header" style={{ backgroundColor: "#f2f1f7" }}>
            <div className="">
              <h5 className="modal-title main-title">
                {modalType === "view"
                  ? "View Sender Details"
                  : modalType === "modify"
                  ? "Modify Sender Details"
                  : "Add Sender ID"}
              </h5>
              {!isReadOnly && (
                <p className="modal-subtitle m-0" style={{ fontSize: "14px" }}>
                  Add new Sender ID by filling the details below
                </p>
              )}
            </div>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleBack}
            ></button>
          </div>
          {errorMessage && (
            <div className="alert alert-danger" role="alert">
              {errorMessage}
            </div>
          )}
          <form onSubmit={handleFormSubmit}>
            <div className="scoped-modal modal-body">
              <div className="mb-3">
                <label htmlFor="custName">Customer Name</label>
                <input
                  type="text"
                  id="custName"
                  className="form-control"
                  value={name}
                  readOnly
                  style={{ cursor: "not-allowed" }}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="custName">Entity ID</label>
                <input
                  type="text"
                  id="custName"
                  className="form-control"
                  value={
                    entityIds.length > 0 ? entityIds : senderDetails?.entityId
                  }
                  readOnly
                  style={{ cursor: "not-allowed" }}
                />
              </div>
              <div className="mb-3">
                <label htmlFor="senderName" className="form-label">
                  Sender Name<span style={{ color: "#DC3545" }}>*</span>
                </label>
                <input
                  type="text"
                  id="senderName"
                  className="form-control"
                  placeholder="Enter Sender Name"
                  value={
                    modalType === "view"
                      ? senderDetails?.name
                      : modalType === "modify"
                      ? senderName
                      : senderName
                  }
                  onChange={(e) => setSenderName(e.target.value)}
                  autoComplete="off"
                  readOnly={modalType === "view"}
                />
                {senderNameError && modalType !== "view" && (
                  <div className="text-danger">{senderNameError}</div>
                )}
              </div>
              <div className="mb-3">
                <label htmlFor="senderId" className="form-label">
                  Sender ID
                  <span style={{ color: "#DC3545" }}>*</span>
                </label>
                <input
                  type="text"
                  id="senderId"
                  maxLength={6}
                  className="form-control"
                  placeholder="Enter Sender ID"
                  value={isReadOnly ? senderDetails?.id : senderId}
                  onChange={(e) => setSenderId(e.target.value)}
                  autoComplete="off"
                  style={{ cursor: isReadOnly ? "not-allowed" : "auto" }}
                />
                {senderIdError && (
                  <div className="text-danger">{senderIdError}</div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-back"
                onClick={handleBack}
              >
                Back
              </button>
              {(modalType === "modify" && modalType !== "view") ||
              !modalType ? (
                <button type="submit" className="btn btn-submit">
                  {loading ? (
                    <CircularProgress
                      className="circular-loader"
                      style={{ width: "20px", height: "20px" }}
                    />
                  ) : modalType === "modify" ? (
                    "Update"
                  ) : (
                    "Add"
                  )}
                </button>
              ) : null}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SenderIDModal;
